import React from 'react';
import { Avatar, AvatarSize } from '../../../ui';
import ProfileLink from '../profile-link/profile-link';
import VisitorAvatar from '../visitor-avatar/visitor-avatar';
import { unreachable } from '../../../ts-utils';
import styles from './user-avatar.module.scss';
export const UserAvatar = ({ className, owner, avatarSize = AvatarSize.medium }) => {
    return (React.createElement("div", { className: className }, (() => {
        switch (owner.type) {
            case 'MEMBER':
                const avatarUrl = owner.member.profile.photo?.url;
                return (React.createElement(ProfileLink, { tabIndex: -1, member: owner.member },
                    React.createElement(Avatar, { className: styles.avatar, src: avatarUrl, size: avatarSize, name: avatarUrl && owner.member.profile.nickname
                            ? owner.member.profile.nickname
                            : undefined })));
            case 'ANONYMOUS':
                return (React.createElement(VisitorAvatar, { size: avatarSize, className: styles.avatar, hexColor: `#${owner.identityId.substring(0, 6)}` }));
            case 'PLACEHOLDER':
            case 'UNKNOWN':
                return React.createElement(Avatar, { className: styles.avatar, size: avatarSize });
            default:
                throw unreachable(owner);
        }
    })()));
};
//# sourceMappingURL=user-avatar.js.map